<template>
  <div>
    <SearchComponent
      :isTime="true"
      :endTimeText="'入库结束日'"
      :startTimeText="'入库起始日'"
      :selectOrInputList="selectOrInputList"
      @on-print="handlePrint"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
    ></SearchComponent>
    <TablePublic
      :arraySpanMethod="objectSpanMethod" 
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :showIndex="false" 
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="index" slot-scope="scope">
         <span>{{ customMergeIndex(indexObj, scope.index) }}</span>
      </template>
      <template slot="statusText" slot-scope="scope">
        <el-tag :type="scope.data.statusTextColor">{{ scope.data.statusText }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-popover
          style="padding: 0 9px;"
          placement="right"
          width="280"
          trigger="manual"
          v-model="scope.data.visible"
          :ref="`popover-${scope.data.id}`"
          @hide="innerCancel"
        >
          <div class="qrCode">
            <div class="qrCode-title">
              <div>{{ scope.data.pickingBatchBizNo }}</div>
              <i class="el-icon el-icon-close" @click="innerCancel"></i>
            </div>
            <div class="qrCode-img">
              <vue-qr :size="120" :logoSrc="qrLogo" :logoScale="0.25" :logoMargin="0" :auto-color="false" :dot-scale="1" :margin="2" :text="scope.data.qrCode" />
            </div>
          </div>
          <el-button
            slot="reference"
            v-hasPermi="[authIdentity + ':detail']"
            type="text"
            size="small"
            class="button"
            @click="innerOpen(scope.data)"
          >溯源码</el-button>
        </el-popover>
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          type="text"
          size="small"
          class="button"
          @click="handleView(scope.data, '查看')"
        >详情</el-button>
      </template>
    </TablePublic>
    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component
        v-if="dialogVisible"
        :ref="currentView"
        :is="currentView"
        @closes="cancel"
      ></component>
    </Mdialog>
  </div>
</template>

<script>
import VueQr from 'vue-qr';
import CONSTANTS from '@/utils/statusConstants'
import { mapState, mapActions } from 'vuex'
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import TablePublic from '@/components/tablePublic'
import skinDetail from '@/views/warehouse/statistic/components/detail'
import { getWarehouseSkinList, getWarehousePullDownList } from '@/api/manage/warehouse'
import { getDropFactoryList } from '@/api/system/manage'
import qrLogo from "@/assets/img/login/logo.png";
export default {
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    skinDetail,
    VueQr
  },
  data() {
    const _this = this
    return {
      qrLogo,
      dialogVisible: false,
      dialogWidth: '',
      title: '',
      currentView: '',
      authIdentity: 'warehouse:statistic',
      colLists: [
        {
          prop: 'index',
          label: '序号',
          isTrue: true,
          formSolt: true,
          width: '55'
        },
        {
          prop: 'inboundBizNo',
          label: '单据编号',
          isTrue: true,
          width: 140,
        },
        {
          prop: 'inventoryLocation',
          label: '仓库',
          isTrue: true,
        },
        {
          prop: 'inboundType',
          label: '入库类型',
          isTrue: true,
          minWidth: 140,
          align: 'left',
          formatter(row) {
            return _this.inboundTypeList.find(d=>d.dictValue == row.inboundType)?.dictLabel
          },
        },
        {
          prop: 'customerName',
          label: '客户名称',
          isTrue: true,
          minWidth: 160,
          align: 'left',
        },
        {
          prop: 'pickingBatchBizNo',
          label: '采摘批次',
          isTrue: true,
          minWidth: 140,
        },
        {
          prop: 'productName',
          label: '产品名称',
          isTrue: true,
        },
        {
          prop: 'locDetails',
          label: '产区',
          isTrue: true,
          width: 120,
          align: 'left',
          formatter(row) {
            return _this.formatLocal(row.locDetails, -1)
          },
        },
        {
          prop: 'year',
          label: '年份',
          isTrue: true,
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'ripenessLevelSpecAttrValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'totalNetWeight',
          label: '总净重（斤）',
          isTrue: true,
          width: 140,
        },
        {
          prop: 'totalBasketCount',
          label: '总框数',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'fullRatedWeight',
          label: '满框定重（斤）',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'fullBasketCount',
          label: '满框框数',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'tailWeight',
          label: '尾框重量（斤）',
          isTrue: true,
          width: 120,
        },
        {
          prop: 'statusText',
          label: '单据状态',
          formSolt: true,
          isTrue: true
        },
        {
          prop: 'stockedTime',
          label: '入库完成日期',
          isTrue: true,
          width: 140,
          formatter(row) {
            return _this.parseTime(row.stockedTime, '{y}-{m}-{d}')
          },
        },
        {
          prop: 'inventoryManager',
          label: '仓管员',
          isTrue: true,
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],

      queryParams: {},
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'inboundType',
          placeholder: '请选择入库类型',
          value: 'dictValue',
          label: 'dictLabel',
          list: [],
          type: 'select',
        },
        {
          model: 'bizNo',
          placeholder: '请输入编号或批次',
          class: 'home',
          type: 'input',
        },
        {
          model: 'customerId',
          placeholder: '请选择客户',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'year',
          placeholder: '请选择采摘年份',
          class: 'home',
          type: 'year',
        },
        {
          model: 'inventoryCode',
          placeholder: '请选择仓库',
          value: 'bizCode',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'status',
          placeholder: '请选择单据状态',
          value: 'value',
          label: 'label',
          list: CONSTANTS.warehouseStatus,
          type: 'select',
        },
      ],
      spanArr1: [], // 记录每一行的合并数
      pos1: '', // 记录索引
      indexObj: {},// 用于记录索引项对应的实际序号
    }
  },
  created() {
    this.getDictList({ types: 'InboundType' })
    this.getWarehousePullDownList()
    this.getDropFactoryList()
    this.getList()
  },
  computed: {
    ...mapState({
      inboundTypeList: (state) => (state.system.dictList && state.system.dictList.InboundType) || [],
      dictList: (state) => state.system.dictList || [],
    }),
  },
  watch:{
    inboundTypeList: {
      handler(val) {
        this.selectOrInputList[0].list = val
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapActions({ getDictList: 'system/getDictList' }),
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getWarehouseSkinList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            let wsLocation = location.host
            let h5Location = ''
            if(!wsLocation.includes('testh5')){
              h5Location = 'https://h5.ytchenpi.com'
            }else{
              h5Location = 'https://testh5.ytchenpi.com'
            }
            this.tableData = res.data.items.map((item) => {
              item.visible = false
              item.statusText = CONSTANTS.getStatusConversion(item.inboundStatus, 'warehouseStatus')
              item.statusTextColor = CONSTANTS.getStatusConversionColor(item.inboundStatus, 'warehouseStatus')
              item.qrCode = `${h5Location}/posterNew?traceabilityCode=${item.pickingBatchBizNo}&tenantId=${item.tenantId}`
              return item
            })
            this.total = res.data.totalCount
            this.getSpanArr(this.tableData)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    getDropFactoryList(){
      getDropFactoryList({type: 1}).then((res) => {
        if (res.flag) {
          this.selectOrInputList[2].list = res.data
        }
      })
    },
    getWarehousePullDownList(){
      getWarehousePullDownList().then((res) => {
        if (res.flag) {
          this.selectOrInputList[4].list = res.data
        }
      })
    },
    handleView(row) {
      this.type = 'preview'
      this.title = '查看入库详情'
      this.currentView = 'skinDetail'
      this.dialogWidth = '60%'
      this.dialogVisible = true
      this.$nextTick(() => {
        if (row) {
          this.$refs[this.currentView].getDetails(row)
        }
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    innerOpen(row) {
      this.innerCancel()
      setTimeout(() => {
        row.visible = true
        const key = "popover-" + row.id
        this.$nextTick(() => {
          let nodeSibling = document.getElementById(this.$refs[key].$refs.popper.id).previousElementSibling
          if(nodeSibling && nodeSibling.id.indexOf('el-popover') != -1){
            nodeSibling.style.display = "none"
          }
        })
      }, 100)
    },
    innerCancel() {
      const classToRemove = 'el-popover';
      const divToRemoveList = document.querySelectorAll(`div.${classToRemove}`);
      divToRemoveList.forEach(div => div.remove());
      this.tableData.some((item) => (item.visible = false))
    },
    handlePrint() {},
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
    // 合并行
    getSpanArr(data) {
      this.spanArr1 = []
      for (let i = 0; i < data.length; i++) {
        // 第一列
        if (i === 0) {
          this.spanArr1.push(1)
          this.pos1 = 0
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].inboundBizNo === data[i - 1].inboundBizNo) {
            this.spanArr1[this.pos1] += 1
            this.spanArr1.push(0)
          } else {
            this.spanArr1.push(1)
            this.pos1 = i
          }
        }
      }
      this.indexObj = this.dealMergeIndexObj(this.spanArr1)
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if ([0, 1, 2, 3].includes(columnIndex)) {
        return {
          rowspan: this.mergeIndexRows(row, this.tableData, rowIndex, ['inboundBizNo']),
          colspan: 1,
        }
      }
      // if (columnIndex === 4) {
      //   return {
      //     rowspan: this.mergeIndexRows(row, this.tableData, rowIndex, ['inventoryLocation']),
      //     colspan: 1,
      //   }
      // }
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
/deep/ .el-button--text {
  font-size: 14px;
}
.qrCode{
  .qrCode-title{
    display: flex;
    justify-content: space-between;
    .el-icon-close{
      font-size: 24px;
      cursor: pointer;
    }
  }
  .qrCode-img{
    display: flex;
    justify-content: center;
    margin: 20px 0;
  }
}
</style>
